import fetch from '../api/fetch'

/**
 * 	Action to fetch policy map markers
 *
 * 	@method GET
 */

export function fecthPolicyMap() {
    return {
        type: 'FETCH_POLICY_MAP',
        payload: fetch(`/dashboard/policymap`, { method: 'GET' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/policyMap.ts